import { render } from "./VitroPayDialog.vue?vue&type=template&id=4cb365e6&scoped=true"
import script from "./VitroPayDialog.vue?vue&type=script&lang=ts"
export * from "./VitroPayDialog.vue?vue&type=script&lang=ts"

import "./VitroPayDialog.vue?vue&type=style&index=0&id=4cb365e6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4cb365e6"

export default script